const SET_WEEK = (state, weekData) => {
  state.week = {
    ...weekData,
  };
};

const SET_WEEK_NUMBER = (state, weekNumber) => {
  state.weekNumber = weekNumber;
};

const SET_SELECTED_WEEK = (state, selectedWeek) => {
  state.selectedWeek = selectedWeek;
};

const SET_DISABLED_DAYS = (state, disabledDays) => {
  state.disabledDays = disabledDays;
};

const SET_DISABLED_EVENTS = (state, disabledEvents) => {
  state.disabledEvents = disabledEvents;
};

const SET_DISABLE_WEEK_FLAG = (state, disabledWeekFlag) => {
  state.disabledWeekFlag = disabledWeekFlag;
};

const SET_IS_DUE_DATE = (state, isDueDate) => {
  state.isDueDate = isDueDate;
};

const VALIDATE_NEW_MENU = (state, isValid) => {
  state.newMenu.isValid = isValid;
};

const VALIDATE_NEW_MENU_UPLOADS = (state, uploadedCorrectly) => {
  state.newMenu.uploadedCorrectly = uploadedCorrectly;
};

const SET_IS_LOADING_MENU = (state, isLoadingMenu) => {
  state.isLoadingMenu = isLoadingMenu;
};

export default {
  SET_WEEK,
  SET_WEEK_NUMBER,
  SET_SELECTED_WEEK,
  SET_DISABLED_DAYS,
  SET_DISABLED_EVENTS,
  SET_DISABLE_WEEK_FLAG,
  SET_IS_DUE_DATE,
  VALIDATE_NEW_MENU,
  VALIDATE_NEW_MENU_UPLOADS,
  SET_IS_LOADING_MENU,
};



// WEBPACK FOOTER //
// ./store/modules/weeklyMenu/mutations.js